import api from './api';

export default async function updateArcAutomarkerQuestion(task_id, body) {
  const { data } = await api.put(`arc-automarker/questions/${task_id}`, body);
  return data;
}